module.exports = __webpack_public_path__ + "static/img/bot_bg.4e2cfb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bot_bg.jpg
// module id = sMXr
// module chunks = 0